/**
 * Which category Capture opens on (SPEC.md §3.1).
 *
 * The profile's default when it is set **and still live**, else the category
 * last used, else the first in the user's order. Each step checks liveness,
 * because each id can name a category another device has since archived or
 * deleted — and a pre-selected radio that is not in the radiogroup is a Save
 * button that writes to a category the user cannot see.
 *
 * Pure. The hook that feeds it is `useStartCategoryId` (`use_data.ts`).
 */
export function startCategoryId(input: {
  defaultId: string | null;
  lastUsedId: string | null;
  /** Live categories in the user's order. */
  live: readonly { id: string }[];
}): string | null {
  const isLive = (id: string | null): id is string =>
    id !== null && input.live.some((c) => c.id === id);
  if (isLive(input.defaultId)) return input.defaultId;
  if (isLive(input.lastUsedId)) return input.lastUsedId;
  return input.live[0]?.id ?? null;
}
